export type IProps = any;

export enum LeadFinderPrimaryTab {
  PEOPLE = 'people',
  COMPANY = 'company',
  CSV_ENRICHMENT = 'csv-enrichment',
}

export enum LeadFinderSecondaryTab {
  TOTAL = 'total',
  NEW = 'netNew',
  SAVED = 'saved',
}

export enum LeadFinderListTab {
  Company = 1,
  People = 2,
}

export enum LeadFinderListVisibility {
  Private = 1,
  Public = 2,
  Team = 3,
}

export enum LeadFinderList {
  AddToList = 'add-to-lists',
  RemoveFromList = 'remove-from-lists',
}

export enum LeadFinderCompanyTagAction {
  AddTag = 'add-tag',
  RemoveTag = 'remove-tag',
}

export type LeadsFindRequestPayload = {
  page: number;
  name?: string;
  keyword?: string;
};

export const FilterComponentType = {
  SEARCH_INPUT: 'searchInput',
  DROP_DOWN: 'dropDown',
  MULTILEVEL_CHECKBOX: 'checkbox',
  TAG_CHECKBOX: 'savedTag',
  SAVED_LEAD_DATE: 'createdDate',
  RADIO_BUTTON: 'radioButton',
  COMPANY_LIST: 'companyList',
  SAVED_LIST: 'savedList',
  GROUP_DROPDOWN: 'groupDropdown',
  EXCLUDE_PROSPECTS: 'excludeProspects',
};

export enum LeadRevealType {
  Email = 'email',
  Phone = 'phone',
  EmailPhone = 'emailphone',
  PersonalEmail = 'personalEmail',
  PersonalEmailPhone = 'personalEmailPhone',
  EmailPersonalEmailPhone = 'emailPersonalEmailPhone',
  EmailPersonalEmail = 'emailPersonalEmail',
  Company = 'company',
}

export const LeadRevealLimit = {
  VALID: 'valid',
  CREDIT_LIMIT_REACHED: 'credit-limit-reached',
  MORE_SELECTED: 'more-selected',
};

export enum BulkLeadsActionType {
  REVEAL_EMAIL = 'reveal_email',
  REVEAL_PERSONAL_EMAIL = 'reveal_personal_email',
  REVEAL_EMAIL_PHONE = 'reveal_email_phone',
  ADD_TO_PROSPECT = 'add_to_prospect',
  ADD_TO_SEQUENCE = 'add_tp_sequence',
  EXPORT = 'export',
  ADD_TAG = 'add_tag',
  REMOVE_TAG = 'remove_tag',
}

export const BULK_ACTION_TIMEOUT = 5000;
export const MAX_POLLING_LIMIT = 20;
export const PEOPLE_MAX_POLLING_LIMIT = 50;

export const RR_PAGINATION_LIMIT = 10000;

export const LEAD_FINDER_REVEAL_LIMIT = 100;

export const FREE_PLAN_PAGINATION_LIMIT = 2;

export const FREE_PLAN_PAGINATION_LIMIT_TOOLTIP = `You can see up to ${FREE_PLAN_PAGINATION_LIMIT} pages on the Free Plan. Upgrade to see all results`;

export const SavedLeadEmailStatus = {
  Valid: 'valid',
  Risky: 'risky',
  Bad: 'bad',
} as const;

export type SavedLeadEmailStatusValue = typeof SavedLeadEmailStatus[keyof typeof SavedLeadEmailStatus];

export type SavedTabFilters = {
  tags: number[];
  createdDate: Date[];
  search: string;
  listIds?: {
    includes: number[];
    excludes: number[];
  };
  excludeProspects?: boolean;
  emailStatus?: SavedLeadEmailStatusValue[];
};

export type AddTagsToLeadsPayload = {
  tagIds: number[];
  leads: number[];
  newTags: string[];
};

export type RemoveTagsToLeadsPayload = {
  tagIds: number[];
  leads: number[];
};

export type BulkActionPayload = {
  deSelectedLeadIds?: number[];
  maxLeadsToBeProcessed?: number;
  leadsFilter?: {
    tags?: number[];
    search?: string;
    createdDate?: any[];
    excludeProspects?: boolean;
    emailStatus?: SavedLeadEmailStatusValue[];
    listIds?: number[];
  };
  newTags?: string[];
  tagIds?: number[];
};

export type BulkActionRemoveTagsPayload = {
  deSelectedLeadIds?: number[];
  maxLeadsToBeProcessed?: number;
  leadsFilter?: {
    tags?: number[];
    search?: string;
    createdDate?: any[];
    excludeProspects?: boolean;
    emailStatus?: SavedLeadEmailStatusValue[];
    listIds?: number[];
  };
  tagIds?: number[];
};

export interface BulkAddToProspectSavedDto {
  deSelectedLeadIds?: number[];
  maxLeadsToBeProcessed?: number;
  leadsFilter: {
    tags?: number[];
    search?: string;
    createdDate?: any[];
    excludeProspects?: boolean;
    emailStatus?: SavedLeadEmailStatusValue[];
    listIds?: number[];
  };
}

export interface BulkAddToSequenceSavedDto {
  sequenceId: number;
  stepId: number;
  deSelectedLeadIds?: number[];
  maxLeadsToBeProcessed?: number;
  leadsFilter: {
    tags?: number[];
    search?: string;
    createdDate?: any[];
    excludeProspects?: boolean;
    emailStatus?: SavedLeadEmailStatusValue[];
    listIds?: number[];
  };
}

export interface BulkLeadRevealPeopleDto {
  leadsFilter: any;
  count: number;
  leadIds: number[];
  newTags?: string[];
  tagIds?: number[];
  revealType: LeadRevealType;
}

export interface BulkLeadExportSavedDto {
  deSelectedLeadIds?: number[];
  maxLeadsToBeProcessed?: number;
  leadsFilter: {
    tags?: number[];
    search?: string;
    createdDate?: any[];
    listIds?: {
      includes?: number[];
      excludes?: number[];
    };
    excludeProspects?: boolean;
    emailStatus?: SavedLeadEmailStatusValue[];
  };
}

// Company export DTOs
export interface BulkCompaniesGetFilterDto {
  tags?: number[];
  search?: string;
  createdDate?: any[];
  listIds?: {
    includes?: number[];
    excludes?: number[];
  };
}

export interface BulkExportCompanyDto {
  deSelectedCompanyIds?: number[];
  maxLeadsToBeProcessed?: number;
  companiesFilter?: BulkCompaniesGetFilterDto;
}

export interface ExportCompanyDto {
  companyIds: number[];
}

export interface CompanyTagActionPayload {
  actionType: LeadFinderCompanyTagAction;
  companyIds: number[];
  tagIds?: number[];
  newTags?: string[];
}

export interface CompanyBulkTagActionPayload {
  actionType: LeadFinderCompanyTagAction;
  tagIds?: number[];
  newTags?: string[];
  maxLeadsToBeProcessed?: number;
  companyFilter: {
    search?: string;
    tagIds?: number[];
    createdDate?: string;
    listIds?: { includes?: number[]; excludes?: number[] };
  };
}

export interface RevealSingleLeadPayload {
  revealLeadId: number;
  leadsFilter: any;
  revealType: LeadRevealType;
}

export interface FetchAISearchResultPayload {
  aiText: string;
  tab?: LeadFinderSecondaryTab;
}

export type LeadExperience = {
  job_title?: string;
  company_name?: string;
  company_website?: string;
};

export interface V2Lead {
  id: number;
  contactId?: number;
  parent_id?: number;
  created_at?: string;
  updated_at?: string;
  checked_at?: string;
  changed_at?: string;
  public_profile_id?: number;
  isRevealed?: boolean;
  revealType?: LeadRevealType;
  isRevealing?: boolean;
  isPersonalEmailRevealing?: boolean;
  isPersonalEmailRevealed?: boolean;
  isCreditRefunded?: boolean;
  reReveal?: boolean;

  full_name?: string;
  picture_url?: string;
  job_title?: string;
  company_id?: number;
  company_name?: string;
  company_logo_url?: string;
  emails?: { email: string; shVerificationStatus: string }[];
  personalEmails?: { email: string; shVerificationStatus: string }[];
  phones?: string[];
  isProspectCreated?: boolean;
  department?: string;
  social_link?: string[];
  linkedin_url?: string;
  github_url?: string;
  location_country?: string;
  location_state?: string;
  location_city?: string;
  company_industry?: string;
  management_level?: string;
  decision_maker?: boolean;
  jobs_changed_within?: string;
  skills?: string[];
  experience_at_current_company?: number;
  current_role_tenure_months?: number;
  total_experience?: number;
  projected_base_salary_dollars?: string;
  education_degrees?: string[];
  institution_name?: string[];
  linkedin_connection_count?: number;
  linkedin_followers_count?: number;
  past_companies?: LeadExperience[];
  active_experiences?: LeadExperience[];
  company_website?: string;
  company_socials?: string[];
  company_domain?: string;
  company_size_range?: string;
  company_annual_revenue?: number;
  company_founded_year?: string;
  company_is_b2b?: boolean;
  company_linkedin?: string;
  company_hq_city?: string;
  company_hq_state?: string;
  company_hq_country?: string;
  company_last_funding_round_amount_raised?: number;
  company_last_funding_date?: string;
  tags?: any[];
  lists?: any[];
  isEnriched?: boolean;
  profile_summary?: string;
  revealFeedback?: RevealFeedback;
  companyEnrichFeedback?: CompanyEnrichFeedback;
}

export interface CompanyEnrichFeedback {
  feedbackSentiment: 'positive' | 'negative';
  feedbackMessage?: string;
}

export interface GetLeadsV2Response {
  payload: V2Lead[];
}

export interface GetLeadsV2CountResponse {
  payload: {
    totalCount?: number;
    netNewCount?: number;
    revealedCount?: number;
  };
}

export interface RevealFeedback {
  sentiment: 'positive' | 'negative';
  message?: string;
}

// Company types
export interface V2Company {
  // Core identification fields
  id?: number; // Mapped from company_id if needed
  company_id?: number;
  company_name?: string;
  website?: string;
  company_logo_url?: string;
  website_domain?: string;

  // Legacy fields for backward compatibility
  name?: string; // Maps to company_name
  logo_url?: string; // Maps to company_logo_url
  domain?: string; // Maps to website_domain

  // Location fields
  hq_location?: string;
  hq_city?: string;
  hq_state?: string;
  hq_country?: string;
  hq_full_address?: string;
  hq_street?: string;
  hq_zipcode?: string;

  // Basic company info
  industry?: string;
  type?: string;
  founded_year?: number | string;
  company_size_range?: string;
  employees_count?: number;
  employee_count?: number; // Legacy compatibility

  // Business classification
  is_b2b?: boolean;
  company_bootstrapped?: boolean;
  is_bootstrapped?: boolean; // Legacy compatibility
  ownership_status?: string;
  ownership_type?: string; // Legacy compatibility
  sic_codes?: string[];
  sic_code?: string; // Legacy compatibility
  naics_codes?: string[];
  naics_code?: string; // Legacy compatibility
  categories_and_keywords?: string[];

  // Social and web presence
  social_urls?: string[];
  socials?: string[]; // Legacy compatibility
  linkedin_url?: string;
  followers_count_linkedin?: number;
  linkedin_followers?: number; // Legacy compatibility

  // Technologies
  technologies_used?: string[];
  technologies?: string[]; // Legacy compatibility

  // Funding information
  last_funding_round_name?: string;
  last_funding_round?: string; // Legacy compatibility
  last_funding_round_amount_raised?: number;
  last_funding_amount?: number; // Legacy compatibility
  last_funding_round_announced_date?: string;
  last_funding_date?: string; // Legacy compatibility
  last_funding_round_num_investors?: number;
  last_funding_round_lead_investors?: string[];
  funding_rounds?: Array<{
    name: string;
    announced_date: string;
    amount_raised: number;
    lead_investors?: string[];
    num_investors?: number;
  }>;

  // Financial metrics
  annual_revenue?: number;
  annual_revenue_currency?: string;
  source_5_annual_revenue?: number;
  ebit?: number | null;
  ebitda?: number | null;
  ebitda_margin?: number | null;
  ebit_margin?: number | null;
  gross_profit?: number | null;
  gross_profit_margin?: number | null;
  net_income?: number | null;
  total_operating_expense?: number | null;
  cost_of_goods_sold?: number | null;
  earning_per_share?: number | null;

  // Stock information
  stock_closing_price?: number | null;
  stock_currency?: string;
  stock_date?: string | null;
  stock_marketcap?: number | null;

  // Employee information
  employees_count_by_department?: Record<string, number | null>;
  employees_count_by_seniority?: Record<string, number | null>;
  department_counts?: Record<string, number>; // Legacy compatibility
  seniority_counts?: Record<string, number>; // Legacy compatibility
  base_salary_title?: string;
  base_salary_salary_median?: number | null;
  base_salary_currency?: string;
  base_salary?: number | null;

  // Employee reviews
  employee_reviews?: {
    total_count?: number | null;
    aggregate_score?: number | null;
    business_outlook?: number | null;
    ceo_approval?: number | null;
    career_opportunities?: number | null;
    recommend?: number | null;
    work_life_balance?: number | null;
    culture_values?: number | null;
  };
  employee_review?: {
    total_count?: number | null;
    aggregate_score?: number | null;
    business_outlook?: number | null;
    ceo_approval?: number | null;
    career_opportunities?: number | null;
    recommend?: number | null;
    work_life_balance?: number | null;
    culture_values?: number | null;
  };
  employee_review_metrics?: Record<string, number>; // Legacy compatibility

  // Job postings
  active_job_postings_count?: number | null;
  active_job_postings_title?: string[];
  active_job_postings?: Array<{
    job_posting_id: number;
    job_posting_title: string;
  }>;
  active_job_openings?: Array<{
    title: string;
    count: number;
  }>; // Legacy compatibility

  // Competitors
  competitors?: Array<{
    company_name: string;
    similarity_score: number;
    competitors_website?: string;
  }>;

  // Website analytics
  total_website_visits_monthly?: number | null;
  website_visitors_last_month?: number; // Legacy compatibility
  visits_breakdown_by_country?: Array<{
    country: string;
    percentage: number;
  }>;
  visits_breakdown_by_gender?: {
    male_percentage?: number;
    female_percentage?: number;
  };
  rank_global?: number | null;

  // Product reviews
  product_reviews_aggregate_score?: number | null;
  product_reviews_count?: number | null;
  product_review_metrics?: Record<string, number>; // Legacy compatibility
  product_reviews_score_change_monthly?: number | null;
  product_reviews_score_change_current?: number | null;
  product_reviews_score_change_quarterly?: number | null;
  product_reviews_score_change_yearly?: number | null;

  // Company description
  description_enriched?: string;
  company_description?: string; // Legacy compatibility

  // Executive changes
  key_executive_departures?: Array<{
    name: string;
    position: string;
    date: string;
  }>;
  key_executive_arrivals?: Array<{
    name: string;
    position: string;
    date: string;
  }>;
  key_executive_departure?: Array<{
    name: string;
    position: string;
    date: string;
  }>; // Legacy compatibility
  key_executive_arrival?: Array<{
    name: string;
    position: string;
    date: string;
  }>; // Legacy compatibility

  // Additional fields (may not be in API response)
  company_phone?: string;
  company_phone_numbers?: string[];
  company_email?: string;
  company_emails?: string[];
  top_topics?: string[];
  product_services?: string[];
  headline_summary?: string;
  earnings_per_share?: number | null;

  // UI/State fields
  isSaved?: boolean;
  tags?: any[];
  created_at?: string;
  company_list_ids?: string[]; // Prototype-parity fields
  lists?: any[];

  // Additional API fields
  employee_growth_6m?: number | null;
  employee_growth_3m?: number | null;
  is_recently_funded?: boolean | null;
  recently_acquired?: boolean | null;
  scaling_product_eng?: boolean | null;
  financially_healthy_growing?: boolean | null;
  cost_optimization_mode?: boolean | null;
  freshly_funded_hiring_fast?: boolean | null;
  active_mna_org_reshuffle?: boolean | null;
  arrival_positions_recent?: string[];
  departure_positions_recent?: string[];
  employees_count_by_month?: Array<{
    employees_count: number;
    date: string;
  }>;
  key_employee_change_events?: any[];
  acquisitions?: any[];
  num_news_articles?: number | null;
  news_articles?: any[];
  company_updates?: any[];
  website_alias?: string[];
  internalId?: number;
  isEnriched?: boolean;
  isRevealing?: boolean;
  isRevealed?: boolean;
  tagsIds?: number[];
  revealType?: string | null;
  revealFeedback?: RevealFeedback;
}

export interface GetCompaniesV2Response {
  payload: {
    profiles: V2Company[];
    pagination: {
      page: number;
      limit: number;
      total: number;
    };
  };
}

export interface GetCompaniesV2CountResponse {
  payload: {
    totalCount?: number;
    netNewCount?: number;
    savedCount?: number;
  };
}

export type LocationV2SuggestionType = 'City' | 'State' | 'Country' | 'Region';

export interface GetV2FilterSuggestionResponse {
  payload: {
    value: string;
    type: LocationV2SuggestionType | string;
    emoji: string;
  }[];
}

export interface LocationV2Item {
  city?: string;
  state?: string;
  country?: string;
  region?: string;
}

export interface LocationV2Filter {
  includes?: LocationV2Item[];
  excludes?: LocationV2Item[];
  exactMatch?: boolean;
  isUnknown?: 0 | 1;
}

export const DISABLED_BY_UNKNOWN_TOOLTIP =
  'This field is disabled because "Is Unknown" is selected. Deselect "Is Unknown" to enable this field.';

export interface CreateListPayload {
  name: string;
  visibility: LeadFinderListVisibility;
  teamIds?: number[];
  tab: LeadFinderListTab;
}

export enum SavedFilterTab {
  PEOPLE = 'people',
  COMPANIES = 'companies',
}

export enum VisitorByGenderFilter {
  MALE = 'male',
  FEMALE = 'female',
  ALL = 'all',
}

export type ExecutiveMember = {
  member_full_name?: string;
  member_position_title?: string;
  arrival_date?: string;
  departure_date?: string;
  // Legacy fields for backward compatibility
  name?: string;
  position?: string;
  date?: string;
};

export type ExecutiveData = ExecutiveMember[] | null | undefined;
